// initial state
const state = {
    initApp: true,
		devicePlatform: null,
    user: {},
    token: null,
    isManager: false,
    mobileData: null,
    mobileIndex: -1,
    navTitle: null,
    lastUpdate: null,
    showLastUpdate: false,
    numAttempts: 0,
    serviceVersion: 'unknown',
    cordovaWrapperVersion: null,
}

// getters
const getters = {
}

// actions
const actions = {
}

// mutations
const mutations = {
  setInitApp(state, initApp) {
    state.initApp = initApp;
  },
  setDevicePlatform(state, devicePlatform) {
    state.devicePlatform = devicePlatform;
  },
  setToken(state, token) {
    state.token = token;
  },
  setIsManager(state, isManager) {
    state.isManager = isManager;
  },
  setUser(state, user) {
    state.user = user;
  },
  setMobileData(state, mobileData) {
    state.mobileData = mobileData;
  },
  setMobileIndex(state, mobileIndex) {
    state.mobileIndex = mobileIndex;
  },
  setNavTitle(state, navTitle) {
    state.navTitle = navTitle;
  },
  setLastUpdate(state, lastUpdate) {
    state.lastUpdate = lastUpdate;
  },
  setShowLastUpdate(state, showLastUpdate) {
    state.showLastUpdate = showLastUpdate;
  },
  setNumAttempts(state, numAttempts) {
    state.numAttempts = numAttempts;
  },
  increaseNumAttempts(state) {
    state.numAttempts++;
  },
  setCordovaWrapperVersion(state, cordovaWrapperVersion) {
    state.cordovaWrapperVersion = cordovaWrapperVersion;
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}